/**
 * Section names for the System Admin left-hand navigation.
 *
 * This is a shared vocabulary, not a registry: pages still declare which section they belong to
 * when they register themselves, and a page passing a name that is not listed here simply gets
 * its own section. Importing a constant only saves a feature from inventing "Configuration " and
 * quietly splitting a section in two.
 *
 * Section ORDER is derived, not declared. NavbarVertical sorts items by priority and then groups
 * them, so a section appears at the position of its highest-priority member — which is why the
 * priorities below are banded per section. Keep a page's priority inside its section's band and
 * both the section order and the order within it follow without anything central to maintain.
 */

export const SECTION_CONFIGURATION = "Configuration"
export const SECTION_OPERATIONS = "Operations"
export const SECTION_ACCESS = "Access"
export const SECTION_CONTENT = "Content"
export const SECTION_DATA = "Data Repair"

// Priority bands, one per section, 100 apart so there is room to insert
export const PRIORITY_CONFIGURATION = 100
export const PRIORITY_OPERATIONS = 200
export const PRIORITY_ACCESS = 300
export const PRIORITY_CONTENT = 400
export const PRIORITY_DATA = 500
